"use client";
import J from "openai";
import { useMemo as R, useState as l, useEffect as W } from "react";
import { useForm as X } from "react-hook-form";
import { getFormDefaultValues as z } from "../../utils/form.js";
import { generateQAModelResponse as Y } from "./actions/qa-model-response.js";
import { generateContextModelResponse as Z } from "./actions/context-model-response.js";
import { useInkeepConfig as ee } from "../../providers/config-provider.js";
import { useInkeepConversation as se } from "../../providers/conversation-provider.js";
import { useChatEvents as re } from "../../providers/chat-events-provider.js";
import { getQAModelMessages as oe } from "./actions/qa-model-messages.js";
import { fetchAndSolveChallenge as te } from "../embedded-chat/use-captcha.js";
const ne = "root.serverError", V = async (c, s) => {
  if (s) return;
  const o = await te(`${c}/v1/challenge`);
  if (o)
    return {
      "X-INKEEP-CHALLENGE-SOLUTION": btoa(JSON.stringify(o))
    };
}, we = (c) => {
  const { formSettings: s } = c, { baseSettings: o } = ee(), { conversation: y } = se(), { logEvent: m } = re(), { aiApiBaseUrl: i, shouldBypassCaptcha: w } = o, S = R(
    () => new J({
      baseURL: `${i}/v1`,
      apiKey: o.apiKey,
      dangerouslyAllowBrowser: !0
    }),
    [o.apiKey, i]
  ), [A, h] = l(!1), [F, I] = l(!1), [N, u] = l(!1), [M, C] = l({}), a = R(() => {
    const { primary: t, secondary: n } = s;
    return z([...t.fields, ...n.fields]);
  }, [s]), {
    control: b,
    handleSubmit: O,
    formState: { errors: v, isSubmitting: P, isSubmitSuccessful: L },
    reset: E,
    trigger: k,
    setValue: x,
    setError: H
  } = X({
    defaultValues: a
  });
  W(() => {
    a && E(a);
  }, [E, a]);
  const K = async (t) => {
    try {
      await s.buttons.submit.onSubmit({
        values: t,
        conversation: y
      }), m({
        eventName: "intelligent_form_submitted",
        properties: {
          conversation: y,
          values: t
        }
      });
    } catch (n) {
      H(ne, {
        message: n instanceof Error ? n.message : "Something went wrong."
      });
    }
  }, B = async () => {
    const t = s.primary.fields.map((e) => e.name);
    if (!await k(t)) return;
    I(!0), h(!0);
    const D = b._formValues, _ = s.primary.fields.reduce(
      (e, d) => (e[d.name] = D[d.name], e),
      {}
    ), G = s.secondary.fields.filter(
      (e) => e.shouldPrefillWithAI !== !1
    ), f = oe(_);
    m(
      {
        eventName: "intelligent_form_primary_section_submitted",
        properties: {}
      },
      f
    );
    try {
      const e = await V(i, w), d = await V(i, w), [r, p] = await Promise.all([
        Y(f, S, e),
        Z(
          { primaryFieldValues: _, fieldsToGenerate: G },
          S,
          d
        )
      ]);
      if (p.suggestedValues)
        for (const [$, j] of Object.entries(p.suggestedValues))
          x($, j);
      const g = r.aiAnnotations?.answerConfidence, Q = g && ["very_confident", "somewhat_confident"].includes(g), T = r.recordsConsidered && r.recordsConsidered.length > 0;
      Q && T && r.answer ? (C({
        answer: r.answer,
        answerConfidence: g,
        recordsConsidered: r.recordsConsidered
      }), m(
        {
          eventName: "intelligent_form_ai_response_provided",
          properties: {
            recordsConsidered: r.recordsConsidered
          }
        },
        [
          ...f,
          { id: Date.now().toString(), role: "assistant", content: r.answer, links: [] }
        ]
      )) : (u(!0), C({
        answer: null,
        recordsConsidered: r.recordsConsidered,
        suggestedValues: p.suggestedValues
      }));
    } catch (e) {
      console.error(e), u(!0);
    } finally {
      h(!1);
    }
  }, U = O(K), q = v?.root?.serverError;
  return {
    formSettings: s,
    control: b,
    errors: v,
    isSubmitSuccessful: L,
    isSubmitting: P,
    handleSubmit: U,
    loading: A,
    formError: q,
    submittedPrimaryForm: F,
    handleSubmitPrimaryForm: B,
    aiResponse: M,
    showSecondaryFields: N,
    setShowSecondaryFields: u
  };
};
export {
  we as useInkeepIntelligentForm
};
